import i18n from 'services/base/i18n';

export default {
  // Confirm the user's icon selection
  ok: () => i18n.pgettext('Components|Select Icon', 'OK'),
};
